import { Component, createEffect, createSignal, For, Match, Show, Switch } from "solid-js"
import { cleanImagePath } from "../api"
import { Img } from "../components/universal/image"
import { Artwork, ArtworkImage, NewImage } from "../types";
import { session } from "../app";
import { A } from "../components/universal/a-href";

type Props = {
    artwork: Artwork;
}

export const MoreImagesTab : Component<Props> = ({ artwork }) => {
    const [canSubscriberDownloadImages, setCanSubscriberDownloadImages ] = createSignal<boolean>(false);
    const megapixels = (height: number|undefined, width: number|undefined) => {
        if (!height || !width) return "";
        const mp = Math.round(height * width / 1000000);
        return mp < 1 ? "less than 1 MP" : mp > 1 ? mp + " MPs" : "1 MP";
    }
    const canOrderPrint = (artworkImage: ArtworkImage) => {
        return true; // TBC
    };
    createEffect(() => {
        const can = session.isLoggedIn && session.member.memberType != "Free";
        console.log({ can });
        setCanSubscriberDownloadImages(can);
    });
    const logWithGoogleAnalytics = (e: Event) => {
        const target = e.currentTarget as HTMLAnchorElement;
        if (window.ga) {
            window.ga('send', 'event', 'download', target.href);
        }
        return true;
    };
    const downloadImage = (image: NewImage) => {
        // if (!!ga) {
        //     ga('send', 'event', 'download', "this.href");
        // }
        window.location.href = cleanImagePath(image.url);
    };
    return (
        <div class="otherimages" style="background-color: #000;">
            <For each={artwork.otherImages}>{(item) =>
                <div class="otherimages-cell">
                    <a href={ "/Common/Image?imageId=" + item.id }>
                        <Img
                            src={ item.url }
                            width={600} mode="max" anchor="topLeft"
                            class="no-clicky-for-you zoomable"
                            style="width: 400px; height: auto;"
                        />
                    </a>
                    <div style="background-color: #000; color: #fff; padding: 5px;">
                        <Switch>
                            <Match when={session.isLoggedIn}>
                                <Switch>
                                    <Match when={artwork.canOrderPrint && session.member.memberType != "Free"}>
                                        <a style="font-size: 2em; color: #928f7d;" title="Download" onClick={(e) => { e.preventDefault(); downloadImage(artwork.primaryImage); }}>
                                            <span class="fa fa-cloud-download"></span> Download
                                        </a>
                                    </Match>
                                    <Match when={artwork.canOrderPrint && session.member.memberType == "Free"}>
                                        <A 
                                            href="/MyARC/Membership/ManageMembership" parameters={{ "returnUrl": "/artwork/index/" + artwork.id }}
                                            style="font-size: 2em; color: #928f7d;" title="Subscribe to donwload">
                                            Subscribe to download
                                        </A>
                                    </Match>
                                </Switch>
                            </Match>
                            <Match when={!session.isLoggedIn}>
                                <Match when={artwork.canOrderPrint}>
                                    <A href="/Home/Login" parameters={{ "returnUrl": "/artwork/index/" + artwork.id }}
                                    style="font-size: 2em; color: #928f7d;" title="Login to download">
                                        Login to download
                                    </A>
                                </Match>
                            </Match>
                        </Switch>
                        {/* <Show when={canSubscriberDownloadImages()}>
                            <div>
                                <p>
                                    <a
                                        target="_blank" style="font-size: 3em; color: #928f7d;"
                                        title="Download image"
                                        onClick={logWithGoogleAnalytics}
                                        href={cleanImagePath(item.url)}>
                                        <span class="fa fa-cloud-download"></span>
                                    </a> <a style="color: #efefef; text-decoration: underline;" href={cleanImagePath(item.url)}>Download High-Res</a>
                                </p>
                            </div>
                        </Show> */}
                        <div>
                            <p style="font-size: 0.75rem;">
                                {item.height} x {item.width} pixels <span class="hd">{megapixels(item.height, item.width)}</span>
                            </p>
                            <Show when={item.fileSizeBytes > 0}>
                                <p style="font-size: 0.75rem;">
                                    {Math.floor(item.fileSizeBytes / 1024)} KBs
                                </p>
                            </Show>
                        </div>
                    </div>
                </div>
            }</For>
        </div>
    )
}